export default __webpack_public_path__ + "static/media/book.3b020674.svg";